const firebaseConfig = {
  apiKey: "AIzaSyC5qlj_-wPGAeWYxVxdatJP-TWpWCFV7Fs",
  authDomain: "mediclinic-7e0d9.firebaseapp.com",
  projectId: "mediclinic-7e0d9",
  storageBucket: "mediclinic-7e0d9.appspot.com",
  messagingSenderId: "299947600451",
  appId: "1:299947600451:web:d79447113969972c9482f6"
};
export default firebaseConfig;  